export default {
    "logout": "Вы вышли из системы",
    "login": "Для входа в систему требуется авторизация",
    "auth/user-not-found": "Пользователя с таким email не существует!",
    "auth/wrong-password": "Неверный пароль!",
    "auth/email-already-in-use": "Пользователь с таким Email уже зарегистрирован!",
}